export const TIMESHEET_LIST_REQUEST = 'TIMESHEET_LIST_REQUEST';
export const TIMESHEET_LIST_SUCCESS = 'TIMESHEET_LIST_SUCCESS';
export const TIMESHEET_LIST_FAIL = 'TIMESHEET_LIST_FAIL';
export const TIMESHEET_CHANGE_REQUEST = 'TIMESHEET_CHANGE_REQUEST';
export const TIMESHEET_CHANGE_SUCCESS = 'TIMESHEET_CHANGE_SUCCESS';
export const TIMESHEET_ALL_CHANGE_SUCCESS = 'TIMESHEET_ALL_CHANGE_SUCCESS';
export const TIMESHEET_CHANGE_FAIL = 'TIMESHEET_CHANGE_FAIL';
